import Vue from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronDown, faVolumeUp, faVolumeMute, faChevronLeft, faEllipsisV,faBars, faList, faArrowLeft, faTimes, faAudioDescription, faLaptopCode } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faTiktok, faTwitch, faTwitter, faYoutube, faSoundcloud } from '@fortawesome/free-brands-svg-icons'

library.add(faAudioDescription)
library.add(faTimes)
library.add(faArrowLeft)
library.add(faLaptopCode)
library.add(faFacebook)
library.add(faYoutube)
library.add(faFacebook)
library.add(faTwitter)
library.add(faTiktok)
library.add(faTwitch)
library.add(faSoundcloud)
library.add(faChevronDown)
library.add(faList)
library.add(faEllipsisV)
library.add(faBars)
library.add(faChevronLeft)
library.add(faVolumeUp)
library.add(faVolumeMute)

Vue.component('font-awesome-icon', FontAwesomeIcon)